import type { HoverPopupFeature, SelectedAsset } from '../types';

const getString = (value: unknown): string | undefined => {
	if (typeof value === 'string' && value.length > 0) return value;
	if (typeof value === 'number') return `${value}`;
	return undefined;
};

const getInstallDate = (
	asset: SelectedAsset,
): string | number | Date | null | undefined => {
	const aliases: Array<
		keyof SelectedAsset | 'install_date' | 'installationDate'
	> = ['installDate', 'install_date', 'installationDate'];

	for (const key of aliases) {
		const value = asset[key] as string | number | Date | null | undefined;
		if (value !== undefined) return value;
	}

	return undefined;
};

export const selectedAssetToHoverPopupFeature = (
	asset: SelectedAsset,
): HoverPopupFeature => {
	const idParts =
		typeof asset.id === 'string' && asset.id.includes('#')
			? asset.id.split('#')
			: undefined;
	const idAssetType = idParts?.[0];
	const idAssetId = idParts?.[1];

	const assetIdFromAliases =
		getString(asset.assetId) ??
		getString(asset.assetID) ??
		getString(asset.asset_id);

	const canonicalAssetId =
		assetIdFromAliases ?? idAssetId ?? getString(asset.id);

	const canonicalAssetType =
		getString(asset.assetType) ??
		getString(asset.asset_type) ??
		idAssetType ??
		getString(asset.type);

	const installDate = getInstallDate(asset);

	return {
		...asset,
		assetId: canonicalAssetId,
		assetType: canonicalAssetType,
		installDate,
	};
};
